<div 
  class="stack-container"
  (mousemove)="onDragOver($event)"
  (mouseleave)="onDragLeave($event)"
>
  <!-- Show placeholder at bottom if position is 0 -->
  <div
    *ngIf="placeholderService.shouldShowProductPlaceholder(dropIndex, shelfIndex, stackIndex, 0)"
    class="product placeholder-product"
  >
    <app-planogram-manual-product
      *ngIf="(placeholderService.placeholder$ | async)?.product"
      [product]="(placeholderService.placeholder$ | async)!.product!"
      [dropIndex]="dropIndex"
      [shelfIndex]="shelfIndex"
      [stackIndex]="stackIndex"
      [productIndex]="-1">
    </app-planogram-manual-product>
  </div>

  @for (product of stack.products; track productIndex; let productIndex = $index) {
    <app-planogram-manual-product
      *ngIf="!product.dragging"
      [product]="product"
      [dropIndex]="dropIndex"
      [shelfIndex]="shelfIndex"
      [stackIndex]="stackIndex"
      [productIndex]="productIndex">
    </app-planogram-manual-product>
    
    <!-- Show placeholder after this product if needed -->
    <div
      *ngIf="placeholderService.shouldShowProductPlaceholder(dropIndex, shelfIndex, stackIndex, productIndex + 1)"
      class="product placeholder-product"
    >
      <app-planogram-manual-product
        *ngIf="(placeholderService.placeholder$ | async)?.product"
        [product]="(placeholderService.placeholder$ | async)!.product!"
        [dropIndex]="dropIndex"
        [shelfIndex]="shelfIndex"
        [stackIndex]="stackIndex"
        [productIndex]="-1">
      </app-planogram-manual-product>
    </div>
  }
</div>